export const TIMELINE_TITLE_MAX_LENGTHApi = 255;
export const TIMELINE_EVENT_DESCRIPTION_MAX_LENGTHApi = 500;
export var TimelineSourceTypeApi;
(function (TimelineSourceTypeApi) {
    TimelineSourceTypeApi["CONTEST"] = "contest";
})(TimelineSourceTypeApi || (TimelineSourceTypeApi = {}));
